const PortfolioWebsite = () => {
  return (
    <div>
      <p>
        I had this portfolio skeleton for a while, but finally decided to build
        it from scratch when I was learning React to familiarize myself more
        with the syntaxes (after writing Angular for so long). It was fun to be
        a little creative again, and reminded me of all the things I've gotten
        to learn over the years. It reinforced my enjoyment for frontend
        development.
      </p>
    </div>
  );
};

export default PortfolioWebsite;
